import React from "react";
import { Stack, TextField, DatePicker, Checkbox, Dropdown, PrimaryButton, DefaultButton, Label, Panel, PanelType, ComboBox, Text } from "office-ui-fabric-react";
import { MyContext } from '../../../context';

// Example state options, replace with your actual states if needed
const stateOptions = [
    { key: 'New', text: 'New' },
    { key: 'InProgress', text: 'In Progress' },
    { key: 'Queued', text: 'Queued' },
    { key: 'Waiting', text: 'Waiting' },
    { key: 'QueuedRnD', text: 'Queued RnD' },
    { key: '930760004', text: '930760004' },
    { key: 'WaitingForSoftwareRelease', text: 'Waiting For Software Release' },
    { key: 'Reopened', text: 'Reopened' },
    { key: 'Resolved', text: 'Resolved' },
    { key: 'Solved', text: 'Solved' },
    { key: 'Canceled', text: 'Canceled' }
];

class FilterPanelTicket extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cycle: this.props.filter?.cycle || "",
            startDate: this.props.filter?.startDate ? new Date(this.props.filter.startDate) : null,
            endDate: this.props.filter?.endDate ? new Date(this.props.filter.endDate) : null,
            grabClosedTickets: this.props.filter?.grabClosedTickets || false,
            state: this.props.filter?.state || [],
            withSave: false,
            error: "" // Add error state
        };
    }

    handleChange = (field, value) => {
        let newState = { [field]: value, error: "" };

        // Mutual exclusivity: if setting startDate or endDate, clear cycle
        if ((field === "startDate" || field === "endDate") && value) {
            newState.cycle = "";
        }
        // If setting cycle to non-empty, clear startDate and endDate
        if (field === "cycle" && value) {
            newState.startDate = null;
            newState.endDate = null;
        }

        // If setting startDate or endDate, validate order
        let startDate = field === "startDate" ? value : this.state.startDate;
        let endDate = field === "endDate" ? value : this.state.endDate;
        if (startDate && endDate && startDate > endDate) {
            newState.error = "startDateBeforeEndDate";
        }

        this.setState(newState);
    };

    handleApply = (withSave) => {
        // Validation before applying

        if (!this.state.cycle && (!this.state.startDate || !this.state.endDate)) {
            this.setState({ error: "addBothDates" });
            return;
        }
        if (this.state.startDate && this.state.endDate && this.state.startDate > this.state.endDate) {
            this.setState({ error: "startDateBeforeEndDate" });
            return;
        }

        this.setState({ withSave: withSave, error: "" });

        let filter = {
            cycle: this.state.cycle,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            grabClosedTickets: this.state.grabClosedTickets,
            state: this.state.state,
        }

        if (this.props.onApply) {
            this.props.onApply(filter, withSave);
        }
        if (this.props.onDismiss) {
            this.props.onDismiss();
        }
    };

    reset = () => {
        this.setState({
            cycle: "",
            startDate: null,
            endDate: null,
            grabClosedTickets: false,
            state: [],
            withSave: false,
            error: ""
        });
        if (this.props.onApply) {
            this.props.onApply(null, true);
        }
        if (this.props.onDismiss) {
            this.props.onDismiss();
        }
    };

    getSelectOptionsCycle = (context) => {
        let allOptions = [
            { key: '', text: "" },
            { key: 'Today', text: context.getTranslation("dashboard", "Today") },
            { key: 'Yesterday', text: context.getTranslation("dashboard", "Yesterday") },
            { key: 'Last24h', text: context.getTranslation("dashboard", "Last24h") },
            { key: 'Last48h', text: context.getTranslation("dashboard", "Last48h") },
            { key: 'Last72h', text: context.getTranslation("dashboard", "Last72h") },
            { key: 'Last96h', text: context.getTranslation("dashboard", "Last96h") },
            { key: 'ThisWeek', text: context.getTranslation("dashboard", "ThisWeek") },
            { key: 'Last7d', text: context.getTranslation("dashboard", "Last7d") },
            { key: 'LastWeek', text: context.getTranslation("dashboard", "LastWeek") },
            { key: 'Last14d', text: context.getTranslation("dashboard", "Last14d") },
            { key: 'ThisMonth', text: context.getTranslation("dashboard", "ThisMonth") },
            { key: 'Last30d', text: context.getTranslation("dashboard", "Last30d") },
            { key: 'Last60d', text: context.getTranslation("dashboard", "Last60d") },
            { key: 'LastMonth', text: context.getTranslation("dashboard", "LastMonth") },
            { key: 'ThisQuarter', text: context.getTranslation("dashboard", "ThisQuarter") },
            { key: 'LastQuarter', text: context.getTranslation("dashboard", "LastQuarter") },
            { key: 'ThisYear', text: context.getTranslation("dashboard", "ThisYear") },
            { key: 'LastYear', text: context.getTranslation("dashboard", "LastYear") },
            { key: 'Last365d', text: context.getTranslation("dashboard", "Last365d") },
            { key: 'Current', text: 'Current' }
        ]

        return allOptions
    }

    render() {
        return (
            <MyContext.Consumer>
                {context => (
                    <Panel
                        isOpen={this.props.isOpen}
                        onDismiss={this.props.onDismiss}
                        headerText={context.getTranslation("configuration", "filter")}
                        closeButtonAriaLabel="Close"
                        type={PanelType.small}
                        isLightDismiss
                    >
                        <Stack tokens={{ childrenGap: 16 }} style={{ padding: 8, maxWidth: 900 }}>
                            {this.state.error && (
                                <Text style={{ color: '#a80000' }}>{context.getTranslation("filterPanel", this.state.error)}</Text>
                            )}

                            <ComboBox
                                label={context.getTranslation("dashboard", "cycle")}
                                selectedKey={this.state.cycle}
                                placeholder={context.getTranslation("common", "selectAnOption")}
                                onChange={(e, option) => this.handleChange("cycle", option.key)}
                                options={this.getSelectOptionsCycle(context)}
                            />

                            <DatePicker
                                label={context.getTranslation("dashboard", "startDate")}
                                value={this.state.startDate}
                                onSelectDate={date => this.handleChange("startDate", date)}
                            />

                            <DatePicker
                                label={context.getTranslation("dashboard", "endDate")}
                                value={this.state.endDate}
                                onSelectDate={date => this.handleChange("endDate", date)}
                            />

                            <Checkbox
                                label={context.getTranslation("filterPanel", "grabClosedTickets")}
                                checked={this.state.grabClosedTickets}
                                onChange={(_, checked) => this.handleChange("grabClosedTickets", checked)}
                            />

                            <Dropdown
                                label={context.getTranslation("configuration", "state")}
                                placeholder={context.getTranslation("common", "multiSelectPlaceholder")}
                                multiSelect
                                options={stateOptions}
                                selectedKeys={this.state.state}
                                onChange={(_, option) => {
                                    const { state } = this.state;
                                    const selectedKeys = option.selected
                                        ? [...state, option.key]
                                        : state.filter(k => k !== option.key);
                                    this.handleChange("state", selectedKeys);       
                                }}
                            />

                            <Stack horizontal tokens={{ childrenGap: 8 }} >
                                <PrimaryButton
                                    text={context.getTranslation("common", "search")}
                                    onClick={() => { this.handleApply(false) }}
                                    styles={{ root: { flexGrow: 1 } }}
                                />
                                <DefaultButton
                                    text={context.getTranslation("common", "save")}
                                    onClick={() => { this.handleApply(true) }}
                                    styles={{ root: { flexGrow: 1 } }}
                                />
                                <DefaultButton
                                    text={context.getTranslation("common", "reset") || "Reset"}
                                    onClick={this.reset}
                                    styles={{ root: { flexGrow: 1 } }}
                                />
                            </Stack>
                        </Stack>
                    </Panel>
                )}
            </MyContext.Consumer>
        );
    }
}

export default FilterPanelTicket;